<ng-container [formGroup]="form">
  <div class="flex gap-4">
    <div class="flex">
      <div>
        <app-form-control>
          <p-date-picker
            [dateFormat]="DATE_RANGE_FORMAT"
            [formControl]="form.controls.createdAt"
            [showButtonBar]="true"
            placeholder="Wybierz zakres dat"
            selectionMode="range" />
        </app-form-control>
      </div>
    </div>

    <div class="ms-auto">
      @if (uploadButtonLabel(); as actionButtonLabel) {
        <p-button
          (onClick)="handleActionButtonClickEvent()"
          [disabled]="uploadButtonDisabled()"
          [label]="actionButtonLabel"
          appPrimengButton
          severity="secondary"
          variant="outlined" />
      }
    </div>

    <div>
      <app-form-control>
        <input
          [formControl]="form.controls.query"
          pInputText
          placeholder="Szukaj" />
      </app-form-control>
    </div>
  </div>
</ng-container>
